import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IssuedCategoryDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-issuedcategory',
  templateUrl: './issuedcategory.component.html',
  styleUrls: ['./issuedcategory.component.scss']
})
export class IssuedCategoryComponent implements OnChanges {


  issuedcategoryForm: FormGroup;
  issuedcategoryFormArray: FormGroup;
  control = new FormControl();
  @Input() issuedcategorys: IssuedCategoryDto[];
  @Input() routeAnimationsElements: any;
  @Output() issuedcategory = new EventEmitter<IssuedCategoryDto[]>()
  @Output() deleteIssuedCategoryEvent = new EventEmitter<any>()

    selectedIssuedCategory: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createIssuedCategoryForm();
    }

    createIssuedCategoryForm() {
      this.issuedcategoryForm = this.fb.group({
        IssuedCategoryName: ['', Validators.required],
     
        id: null
        });
        this.issuedcategoryFormArray = this.fb.group({ IssuedCategorys: this.fb.array([])
          });
        this.setIssuedCategory();
    }

  // method to display issuedcategorys
  setIssuedCategory() {
    const control  = this.issuedcategoryFormArray.controls.IssuedCategorys as FormArray;
    this.issuedcategorys.forEach( e => {
      control.push(
        this.fb.group({
          IssuedCategoryName: e.IssuedCategoryName,
        
          id: e.id
        })
      );
    });
  }


  // method to add IssuedCategory
  addIssuedCategory(value: IssuedCategoryDto) {
    const control  = this.issuedcategoryFormArray.controls.IssuedCategorys as FormArray;
    control.insert(0,
          this.fb.group({
            IssuedCategoryName: value.IssuedCategoryName,
          
            id: null
          })
       );
  }

  selectIssuedCategory(value) {}

  // method to delete issuedcategory from arrary list
  deleteIssuedCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.issuedcategoryFormArray.controls.IssuedCategorys as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.issuedcategorys.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.issuedcategorys[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: IssuedCategoryDto) {
    if(this.issuedcategoryForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.issuedcategoryFormArray.get('IssuedCategorys')['controls'][this.selectedIndex].patchValue({IssuedCategoryName: formValue.IssuedCategoryName});
    } else {
      this.addIssuedCategory(formValue);
    }
    this.selectedIndex = null;
    this.issuedcategoryForm.reset()
  }

  onEdit(index, value: IssuedCategoryDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.issuedcategoryForm.patchValue({IssuedCategoryName: value.IssuedCategoryName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.issuedcategoryForm.reset();
  }

  onSubmit(formValue: IssuedCategoryDto[]) {
  this.issuedcategory.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteIssuedCategoryEvent.emit(this.filteredDelete);
  }
  }

}
